import directives from './module';
import {Utils} from 'underscore-extensions';
import {LocalStorageSvc} from '../services/LocalStorageSvc';

const disabledStates = ['emotions-campaign'];

directives.directive('headroom', ($rootScope: any,
                                  $state: ng.ui.IStateService,
                                  LocalStorageSvc: LocalStorageSvc) => {
        return (scope: ng.IScope, element: ng.IAugmentedJQuery) => {
            const header         = element[0];
            let headerHeight     = 72; // just hardcode, can be even null, but this should be better
            let isTop            = true;
            let lastKnownScrollY = 0;

            window.addEventListener('scroll', _.throttle(() => Utils.rAF(() => {
                if (document.documentElement.classList.contains('noscroll')) {
                    return;
                }
                if (disabledStates.includes($state.current.name)) {
                    header.classList.remove('not-top');
                    return;
                }
                const scrollY = window.scrollY || window.pageYOffset;
                if (scrollY >= headerHeight && isTop) {
                    isTop = false;
                    header.classList.add('not-top');
                    if (!LocalStorageSvc.get('banner-shown')) {
                        $rootScope.$apply(() => {
                            $rootScope.headerNotTop = true;
                            LocalStorageSvc.set('banner-shown', true);
                        });
                    }
                } else if (scrollY < headerHeight && !isTop) {
                    isTop = true;
                    header.classList.remove('not-top');
                }
                if (scrollY < lastKnownScrollY) {
                    header.classList.add('scrolled-up');
                } else if (scrollY > lastKnownScrollY) {
                    header.classList.remove('scrolled-up');
                }
                lastKnownScrollY = scrollY;
            }), 50));
        };
    }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/headroomDirective.ts